import React from "react";
import "./Footer.css";
import { FaInstagram, FaFacebookF } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Left Section - Logo and Social Media */}
        <div className="footer-left">
          <img
            src="/oraoST_beo-tr.png"
            alt="Serbian Trophy Logo"
            className="footer-logo"
          />
          <div className="footer-social">
            <a
              href="https://www.instagram.com/serbiantrophy/?igshid=MzRlODBiNWFlZA%3D%3D"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/SerbianTrophy?mibextid=ZbWKwL"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>
        </div>

        {/* Right Section - Navigation Links */}
        <div className="footer-right">
          <div className="footer-column">
            <h4>RACE INFO</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About he race</a>
              </li>
              <li>
                <a href="/results">Results</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <p className="footer-copyright">
        Serbian Trophy © 2025. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
